import { render, staticRenderFns } from "./TableWithoutWrapper.vue?vue&type=template&id=163637e7&"
import script from "./TableWithoutWrapper.vue?vue&type=script&lang=js&"
export * from "./TableWithoutWrapper.vue?vue&type=script&lang=js&"
import style0 from "./TableWithoutWrapper.vue?vue&type=style&index=0&id=163637e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports